"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgBoltOff = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "m13.791 16.071 4.917 4.917 1.402-1.403L4.402 3.878 3 5.28l5.537 5.537-1.364 2.403c-.02.04.12-.22-.07.12-.19.34-.2.66.38.66h3.5l-1 7h1s.934-1.644 2.808-4.929ZM16.883 10.66l-1.03 1.803L13.388 10h3.094c.49 0 .56.33.47.51l-.07.15ZM13.983 3l-.95 6.645-2.44-2.442L12.982 3h1Z" })), 'SvgBoltOff');
exports.default = SvgBoltOff;
